export function SectionHeading({ eyebrow, title, subtitle, align = "left", action }) {
  return (
    <div className={`flex flex-col ${align === "center" ? "items-center text-center" : "sm:flex-row sm:items-end sm:justify-between"} gap-3 mb-8 lg:mb-10`}>
      <div className={align === "center" ? "max-w-2xl" : ""}>
        {eyebrow && <span className="text-xs sm:text-sm font-bold uppercase tracking-wider text-pbs-purple">{eyebrow}</span>}
        <h2 className="mt-1.5 text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-pbs-dark">{title}</h2>
        {subtitle && <p className="mt-2.5 text-base text-pbs-grey leading-relaxed max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export default SectionHeading;
